import { render, staticRenderFns } from "./UserReports.vue?vue&type=template&id=5d3dca4f&scoped=true&"
import script from "./UserReports.vue?vue&type=script&lang=js&"
export * from "./UserReports.vue?vue&type=script&lang=js&"
import style0 from "./UserReports.vue?vue&type=style&index=0&id=5d3dca4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3dca4f",
  null
  
)

export default component.exports